import type {CromModel} from '../../domain/Crom/Crom.model';

export abstract class FetchCromByIdQuery {
  abstract fetchById(cromId: string): FetchCromByIdQuery.Response;
}

export namespace FetchCromByIdQuery {
  export type Response = Promise<CromModel>;
}
